import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import { FaUserTie, FaHandshake, FaLaptopCode } from 'react-icons/fa';

const testimonialData = [
    {
        icon: FaUserTie,
        name: 'Mohamed Salahudeen',
        designation: 'Chief Technology Officer (CTO)',
        location: 'Tirunelveli, Tamil Nadu',
        description:
            '“At Jaz Infotech, we build custom software, CRM, ERP, and AI automation solutions that help businesses scale. Our focus is clear strategy, reliable delivery, and long-term technology partnerships.”',
    },
    {
        icon: FaHandshake,
        name: 'Mohamed Abbas',
        designation: 'Co-Founder',
        location: 'Tirunelveli, Tamil Nadu',
        description:
            '“As Co-Founder of Jaz Infotech, I work with businesses to strengthen their brand and streamline operations through smart IT outsourcing and digital solutions that deliver real results.”',
    },
    {
        icon: FaUserTie,
        name: 'Mohamed Vaseem',
        designation: 'Managing Director',
        location: 'Tirunelveli, Tamil Nadu',
        description:
            '“I develop reliable web and software solutions at Jaz Infotech — modern, responsive applications built with clean code and a strong focus on performance and user experience.”',
    },
];

const TestimonialOne = ({ column, teamStyle }) => {
    return (
        <div className="row row--15">
            {testimonialData.map((data, index) => {
                const Icon = data.icon;
                return (
                    <div className={`${column}`} key={index}>
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}
                        >
                            <div className={`rn-box-card ${teamStyle}`}>
                                <div className="inner">
                                    <figure className="thumbnail">
                                        <div className="testimonial-icon-avatar" aria-hidden="true">
                                            <Icon />
                                        </div>
                                    </figure>
                                    <figcaption className="content">
                                        <p className="description">{data.description}</p>
                                        <h2 className="title">{data.name}</h2>
                                        <h6 className="subtitle theme-gradient">{data.designation}</h6>
                                        <p className="subtitle b2 mt--5">{data.location}</p>
                                    </figcaption>
                                </div>
                            </div>
                        </ScrollAnimation>
                    </div>
                );
            })}
        </div>
    );
};

export default TestimonialOne;
